import React from 'react';

import { MdImportantDevices } from 'react-icons/md';
import { FCWithChildren } from '@types';

const EmptyDevices: FCWithChildren<{}> = () => (
  <div className="w-full flex gap-4 items-center">
    <div className="rounded-full h-32 w-32 bg-gray-300 flex items-center justify-center">
      <MdImportantDevices className="text-gray-400" size={50} />
    </div>
    <div className="flex flex-col gap-2">
      <h3 className="text-xl text-gray-600 font-semibold">Registered Devices</h3>
      <div>
        <p className="text-base text-gray-600">You do not have any devices.</p>
        <p className="text-base text-gray-600">Add a device by entering the MAC address above.</p>
      </div>
    </div>
  </div>
);

export default EmptyDevices;
